<section class="metrics">
  <h2>{{ 'menu.metrics' | translate }}</h2>

  <section class="metrics-settings" aria-label="{{ 'metrics.timezone_label' | translate }}">
    <div class="field timezone-field">
      <span class="field-label">{{ 'metrics.timezone_label' | translate }}</span>
      <app-timezone-selector
        [options]="timezoneOptions"
        [value]="selectedTimezone()"
        (valueChange)="onTimezoneChange($event)"
      />
    </div>
    <p class="timezone-hint">{{ 'metrics.timezone_hint' | translate }}</p>
  </section>

  <div class="cards">
    <article class="card">
      <div class="card-header">
        <span class="material-symbols-outlined">download</span>
        <h3>{{ 'metrics.card_recent_title' | translate }}</h3>
      </div>
      <p class="card-desc">{{ 'metrics.card_recent_desc' | translate }}</p>
      <div class="card-actions">
        <button class="button" type="button" (click)="openRecentDialog()" [disabled]="downloadingRecent()">
          <ng-container *ngIf="!downloadingRecent(); else recentLoading">
            <span class="material-symbols-outlined icon">schedule</span>
            <span>{{ 'metrics.download' | translate }}</span>
          </ng-container>
          <ng-template #recentLoading>
            <span class="spinner" aria-hidden="true"></span>
          </ng-template>
        </button>
      </div>
    </article>

    <article class="card">
      <div class="card-header">
        <span class="material-symbols-outlined">file_download</span>
        <h3>{{ 'metrics.card_accepted_title' | translate }}</h3>
      </div>
      <p class="card-desc">{{ 'metrics.card_accepted_desc' | translate }}</p>
      <div class="card-actions">
        <button class="button" type="button" (click)="downloadAcceptedOptimizations()" [disabled]="downloadingAccepted()">
          <ng-container *ngIf="!downloadingAccepted(); else acceptedLoading">
            <span class="material-symbols-outlined icon">insights</span>
            <span>{{ 'metrics.download' | translate }}</span>
          </ng-container>
          <ng-template #acceptedLoading>
            <span class="spinner" aria-hidden="true"></span>
          </ng-template>
        </button>
      </div>
    </article>

    <article class="card">
      <div class="card-header">
        <span class="material-symbols-outlined">table_view</span>
        <h3>{{ 'metrics.card_opps_title' | translate }}</h3>
      </div>
      <p class="card-desc">{{ 'metrics.card_opps_desc' | translate }}</p>
      <div class="card-actions">
        <button class="button" type="button" (click)="openOppsDialog()" [disabled]="downloadingOpps()">
          <ng-container *ngIf="!downloadingOpps(); else oppsLoading">
            <span class="material-symbols-outlined icon">download</span>
            <span>{{ 'metrics.download' | translate }}</span>
          </ng-container>
          <ng-template #oppsLoading>
            <span class="spinner" aria-hidden="true"></span>
          </ng-template>
        </button>
      </div>
    </article>
  </div>

  <app-days-range-dialog
    *ngIf="showDaysDialog()"
    (closed)="closeRecentDialog()"
    (submit)="onConfirmDays($event.days)"
    [min]="1"
    [max]="60"
  />

  <app-days-range-dialog
    *ngIf="showOppsDialog()"
    (closed)="closeOppsDialog()"
    (submit)="onConfirmOpps($event)"
    [min]="1"
    [showIncludeNotifications]="true"
    [showIncludeViolations]="true"
  />
</section>


